import { Button, Form, Input, message, Modal, Select, Tabs } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import IntlMessage from "../../components/IntlMessage";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import UploadImage from "../../components/Elements/UploadImage";
import { debounce } from "lodash";
import seatMapApi from "../../api/seat-map";
import { useMounted } from "../../hooks/useMounted";
import vehiclesApi from "../../api/vehicle";
import { useSelector } from "react-redux";

const { Option } = Select;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const VehicleForm = (props) => {
  const { onClose, currentData, open } = props;

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const intl = useIntl();
  const [imgs, setImgs] = useState(null);
  const [seatMaps, setSeatMaps] = useState([]);
  const operator = useSelector((state) => state.auth.operator);

  let initialValues = {
    ...currentData,
    description: currentData?.description ?? "",
    operator_id: currentData?.operator?.id ?? null,
    seatmap_id: currentData?.seatmap?.id ?? null,
  };

  useEffect(() => {
    const fetch = async () => {
      if (operator) {
        const payload = {
          page: 1,
          limit: 100,
          keyword: "",
          order_by: "title",
          order_dir: "ASC",
          filter_name: ["operator_id"],
          filter_value: [operator?.id],
        };
        const res = await seatMapApi.getAll(payload);
        let seatMapData = res?.data;

        if (Array.isArray(seatMapData)) {
          setSeatMaps(seatMapData);
        }
      } else {
        setSeatMaps([]);
      }
    };
    fetch();
  }, [operator]);
  const handleSubmit = () => {
    setLoading(true);
    form
      .validateFields()
      .then((values) => {
        // console.log('submit', values);
        values.operator_id = operator?.id;
        const data = { ...values };
        delete data?.image;

        const payload = new FormData();
        Object.keys(data).forEach((key) => {
          payload.append(key, data[key]);
        });
        if (imgs) {
          payload.append("image", imgs);
        }

        if (currentData) {
          vehiclesApi
            .update(currentData.id, payload)
            .then((res) => {
              if (res?.statusCode === 400) {
                Modal.error({
                  title: res?.message,
                  okText: intl.formatMessage({ id: "global.close" }),
                });
                setLoading(false);
              } else {
                setLoading(false);
                handleCancel();
                message.success("Update vehicle successfully");
                props.onReload();
              }
            })
            .catch((error) => {
              console.error(error);
              setLoading(false);
            });
        } else {
          vehiclesApi
            .create(payload)
            .then((res) => {
              if (res?.statusCode === 400) {
                Modal.error({
                  title: res?.message,
                  okText: intl.formatMessage({ id: "global.close" }),
                });
                setLoading(false);
              } else {
                setLoading(false);
                handleCancel();
                message.success("Create vehicle successfully");
                props.onReload();
              }
            })
            .catch((error) => {
              console.error(error);
              setLoading(false);
            });
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  const handleCancel = () => {
    onClose();
  };

  const onChangeImage = (v, f) => {
    setImgs(f);
  };

  const fileList = useMemo(
    () =>
      currentData && currentData.image
        ? [
            {
              uid: "1",
              name: "image.png",
              status: "done ",
              url: currentData.image,
            },
          ]
        : [],
    [currentData]
  );

  const handleSearchSeatMap = debounce(async (value) => {
    try {
      if (operator) {
        const payload = {
          page: 1,
          limit: value === "" ? 10 : 9999,
          keyword: value || "",
          order_by: "title",
          order_dir: "ASC",
          filter_name: ["operator_id"],
          filter_value: [operator?.id],
        };
        const res = await seatMapApi.getAll(payload);
        let seatMapData = res?.data;

        if (Array.isArray(seatMapData)) {
          setSeatMaps(seatMapData);
        }
      } else {
        setSeatMaps([]);
      }
    } catch (error) {
      console.error(error);
    }
  }, 300);

  const onChangeSeatMap = (e) => {
    // setSeatMapSelected(e);
  };

  const tabItems = [
    {
      key: "1",
      label: <IntlMessage id="global.vehicles" />,
      children: (
        <>
          {/* <Form.Item
            name="operator_id"
            label={<IntlMessage id="global.operator" />}
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Select
              showSearch
              onChange={onChangeOperator}
              filterOption={false}
              onSearch={handleSearchOperator}
              placeholder={intl.formatMessage({
                id: 'placeholder.select_operator',
              })}
            >
              {operators.map((item, index) => {
                return (
                  <Option value={item.id} key={index}>
                    {item.title}
                  </Option>
                );
              })}
            </Select>
          </Form.Item> */}
          <Form.Item
            name="seatmap_id"
            label={<IntlMessage id="global.seat_map" />}
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Select
              showSearch
              onChange={onChangeSeatMap}
              filterOption={false}
              onSearch={handleSearchSeatMap}
              placeholder={intl.formatMessage({
                id: "placeholder.select_seat_map",
              })}
            >
              {seatMaps.map((item, index) => {
                return (
                  <Option value={item.id} key={index}>
                    {item.title}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.title" />}
            name="title"
            rules={[
              {
                required: true,
                whitespace: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Input placeholder="Input title" />
          </Form.Item>
          {/* <Form.Item
            label={<IntlMessage id="global.serial" />}
            name="serial"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input placeholder="Input serial" />
          </Form.Item> */}
          <Form.Item
            label={<IntlMessage id="global.description" />}
            name="description"
            rules={[
              {
                required: false,
              },
            ]}
            // valuePropName="data"
            // getValueFromEvent={(event, editor) => {
            //   const data = editor.getData();
            //   return data;
            // }}
          >
            {/* <CKEditor editor={ClassicEditor} /> */}
            <Input.TextArea
              placeholder="Input description"
              autoSize={{ minRows: 6 }}
            />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.image" />}
            name="image"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <UploadImage onChangeData={onChangeImage} initList={fileList} />
          </Form.Item>
        </>
      ),
    },
  ];

  return (
    <>
      <Modal
        title={
          currentData ? (
            <IntlMessage id="global.edit" />
          ) : (
            <IntlMessage id="global.add" />
          )
        }
        open={open}
        destroyOnClose={true}
        onCancel={handleCancel}
        width="80%"
        onOk={handleSubmit}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            {<IntlMessage id="global.cancel" />}
          </Button>,
          <Button
            key="submit"
            type="primary"
            htmlType="submit"
            loading={loading}
            onClick={handleSubmit}
          >
            {<IntlMessage id="global.save" />}
          </Button>,
        ]}
      >
        <Form
          {...layout}
          form={form}
          initialValues={initialValues}
          labelAlign="left"
          onFinish={handleSubmit}
          onFinishFailed={onFinishFailed}
        >
          <Tabs defaultActiveKey="1" items={tabItems}></Tabs>
        </Form>
      </Modal>
    </>
  );
};

export default VehicleForm;
